<template>
  <div>
    <iframe  :src="url" frameborder="0" style="border:0" ></iframe>
  </div>
</template>

<script>
export default {
  name: 'WebView',
  props: {
    url: String
  },
};
</script>
<style>

</style>
